import { TaskFilters, TaskListItem } from "@myapp/contract";
import { useInfinitePaginated } from "../../../../shared/hooks/useInfinitePaginated";
import { taskKeys } from "../task.keys";
import { taskApi } from "../service";

export function useTasksInfiniteQuery(filters: TaskFilters) {
  return useInfinitePaginated<TaskFilters, TaskListItem>({
    queryKey: taskKeys.list(filters),
    params: filters,
    fetchFn: ({ page, ...rest }) =>
      taskApi.search({ ...rest, page }).then((response) => response.data),
    retry: false,
  });
}
